export default __webpack_public_path__ + "static/media/group-3.cc654fc3.png";